import axios from 'axios';
import { URL_POST_USER_LOGIN } from '../../constants/urls.js';

const postLogin = async (loginData) => {
	const { data } = await axios({
		method: 'POST',
		url: URL_POST_USER_LOGIN,
		data: { payload: loginData },
	});

	if (data.Success) {
		return data;
	} else {
		throw new Error('Login Error');
	}
};

export default postLogin;
